import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import Icon from 'common/components/elements/icons';
import BenefitCard from 'common/components/modules/memberships/benefit-card';
// import NumberFormatter from 'admin/utils/NumberFormatter';
import cx from 'classnames';
import TruncateText from 'common/components/elements/truncate-text';
// const numberFormatter = new NumberFormatter();
import lightPromoVector from 'assets/images/promo-vector.png'
import darkPromoVector from 'assets/images/promo-vector-dark.png'
import DateFormatter from 'common/utils/DateFormatter';

const MembershipItem = ({
   value,
   onClickJoin,
   goToJoin,
   availableForContentName,
   price,
   accessType,
   isAvalable,
   isUpdate,
   updateMembership,
   isPromo,
   promotion,
   screenWidth,
   discountedTerms,
   isTokenExists,
}) => {
   let ref = React.useRef();
   let titleRef = React.useRef();
   const [isReadMore, setIsReadMore] = useState(true);
   const [showReadMore, setShowReadMore] = useState(false);
   const [maxH, setMaxh] = useState('');
   const [height, setHeight] = useState('');
   const [minHeight, setMinHeight] = useState(0);

   const getAditionalState = () => {
      if(!availableForContentName){
         return null;
      }
      let aditionalText = 'is not available with this membership';
      let color = 'error';
      let iconName = 'close'
      if(isAvalable) {
         aditionalText = 'is included with this membership';
         color = 'success';
         iconName = 'unlocked';
         if(price && 'locked' === accessType) {
            color = 'warning';
            iconName = 'lock';
            aditionalText = `is included with this membership for an additional ${ price } USD`;
         }
         if('can_read_and_cannot_message' === accessType){
            aditionalText = 'Only view access to Livestream chat';
            color = 'warning';
            iconName = 'done';
         }
      }
      return { text: aditionalText, color, iconName };
   }


   useEffect(() => {
      const cardMaxHeight = 557; // Card max height
      let titleHeight = 160; // min title height;
      if(titleRef.current) {
         titleHeight = titleRef.current.getBoundingClientRect().height;
      }
      const showMoreHeight = 52; // show more button - height(36px) +  margintop(16px)
      let cardPadding = screenWidth <= 700 ? 40 : 72; //card padding button
      if(isPromo){
         cardPadding = 38 // card padding button(10px) + promotion margin top(28px)
         titleHeight = titleHeight + 60; // + promo card height(60px)
      }
      titleHeight = titleHeight + 24 // + description margin button(24px)
      const descriptionMaxHeight = cardMaxHeight - cardPadding - showMoreHeight - titleHeight
      let descriptionHeight = 0;
      if(ref.current) {
         descriptionHeight = ref.current.scrollHeight;
      }
      if(ref.current) {
         setHeight(descriptionHeight);
         if(descriptionHeight > descriptionMaxHeight){
            setMaxh(descriptionMaxHeight)
            ref.current.classList.add('overflow-hidden');
            setShowReadMore(true);
         } else {
            setMaxh(descriptionMaxHeight)
            setShowReadMore(false);
            ref.current.classList.add(`min-h-[${ descriptionMaxHeight }px]`);
         }
         setMinHeight(descriptionMaxHeight)
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isPromo, screenWidth, ref, ref.current])

   const onSetIsReadMore = () => {
      setIsReadMore(!isReadMore);
      if(!isReadMore) {
         setMaxh(minHeight)
         ref.current.classList.add('overflow-hidden');
      } else {
         setMaxh(height)
         ref.current.classList.remove('overflow-auto');
      }
   }
   const aditionalState = getAditionalState();
   return (
      <div
         className='shadow dark:shadow-dark flex flex-col bg-panel border-divider overflow-hidden h-auto relative min-h-[557px] [@media(max-width:768px)]:min-h-[auto]
          rounded-lg dark:bg-panel-dark dark:border-divider-dark'
      >
         {
            availableForContentName && aditionalState && (
               <div
                  className={ `w-full items-center flex flex-col rounded-t-lg justify-center px-6 py-1 border border-divider dark:border-divider-dark  min-h-[52px] bg-${ aditionalState.color }-12 dark:bg-${ aditionalState.color }-dark-12` }>
                  <div className='flex h-5 items-center max-w-full'>
                     <div className='flex w-4 h-4 min-w-[16px] mr-1 items-center justify-center'>
                        <Icon
                           name={ aditionalState.iconName }
                           color={ aditionalState.color  }
                           style={ {
                              fontSize: '14px',
                           } }
                        />
                     </div>
                     <TruncateText
                        text={ availableForContentName }
                        textClass='text-[#1D2939] dark:text-major-dark text-center text-xs leading-[20px] font-semibold'
                        textSize='12px'
                        fontWeight='600'
                        width='calc(100% - 20px)'
                     />

                  </div>
                  <span className='text-[#1D2939] dark:text-major-dark text-center text-xs leading-[20px] font-semibold'>
                     {aditionalState.text}
                  </span>
               </div>
            )
         }

         {
            isPromo && (
               <>
                  <div
                     className={ cx({
                        'w-full flex flex-col items-center': true,
                        'mt-4': (availableForContentName && aditionalState),
                        'mt-[28px]': !(availableForContentName && aditionalState),
                     }) }
                  >
                     <TruncateText
                        text={ promotion.name }
                        textClass='text-sm font-semibold text-major leading-4 dark:text-major-dark'
                        width={ `calc(100% - ${ screenWidth < 701 ? '130px' : '200px' })` }
                        className='w-full flex justify-center'
                        textSize='14px'
                        fontWeight='600'
                     />
                     <span
                        className='text-sm font-medium mt-1 text-major leading-4 dark:text-major-dark'
                     >
                        { promotion.discount_percentage }% off { promotion.discount_type === 'first_payment' ? 'first payment' : 'all payments' }
                     </span>
                     <span className='text-sm font-semibold mt-2 text-major leading-4 dark:text-major-dark'>Ends in { DateFormatter.getDateLeftInDays(promotion.expiration_date) }</span>
                  </div>
                  <div
                     className={ cx({
                        'absolute left-[-10px]': true,
                        'w-[113px] h-[70px]': screenWidth >= 701,
                        'w-[76px] h-[58px]': screenWidth < 701,
                        'top-[73px]': (availableForContentName && aditionalState),
                        'top-[21px]': !(availableForContentName && aditionalState),
                     }) }
                  >
                     <div className='w-full h-full flex items-center justify-center relative'>
                        <img src={ window?.site_dark_bg ? darkPromoVector : lightPromoVector } alt='promotion' className='w-full h-full absolute z-0' />
                        <span
                           className={ cx({
                              'rotate-[-8deg] z-2 font-bold text-major': true,
                              'text-lg leading-[22px] mr-1.5': screenWidth >= 701,
                              'text-sm leading-[15px] mr-1': screenWidth < 701,
                           }) }
                        >
                           Promo
                        </span>
                     </div>
                  </div>
               </>
            )
         }

         <div
            className={ cx({
               'flex flex-col items-center  px-6 flex-1': true,
               'mt-[58px]': availableForContentName && !isPromo,
               'pt-[72px] [@media(max-width:768px)]:pt-10': !availableForContentName && !isPromo,
               'pt-2.5': !availableForContentName && isPromo,
               'pt-[22px]': availableForContentName && isPromo,
               '[@media(max-width:768px)]:pb-16': !showReadMore,
            }) }

         >
            <div
               ref={ titleRef }
               className='flex flex-col items-center w-full'>
               {
                  !isPromo && (
                     <div className='w-8 h-8 rounded-full bg-success-12 dark:bg-success-dark-12 flex items-center justify-center mb-2'>
                        <Icon name='membership' color='success' darkColor='success-dark' size='lg' />
                     </div>
                  )
               }
               <TruncateText
                  className='mb-2 text-center h-8 w-full'
                  text={ value.name }
                  textClass='font-medium text-2xl text-major leading-[32px] dark:text-major-dark cursor-default'
                  textSize='24px'
                  fontWeight='500'
                  width='calc(100% - 4px)'
               />
               <span
                  // className='font-medium text-secondary dark:text-secondary-dark text-sm leading-[20px] dark:text-secondary-dark text-center'
                  className={ cx({
                     'font-medium text-secondary text-sm leading-[20px] dark:text-secondary-dark text-center cursor-default': true,
                     'line-through': isPromo,
                  }) }
               >

                  {
                     value?.is_can_not_use_trial && value.usd_terms_initial && (
                        <>
                           <span
                              data-tooltip-content={ isPromo ? '' : 'This trial has already been used' }
                              data-tooltip-id='ams-bottom-tooltip'
                              className='line-through'>{value.usd_terms_initial}, then</span>
                        &nbsp;
                        </>
                     )
                  }
                  {value?.is_can_not_use_trial ? value.recurring_terms : value.usd_terms}
               </span>
               {
                  isPromo && (
                     <span
                        className='font-medium text-major text-sm leading-[20px] dark:text-major-dark text-center mt-2'
                     >
                        {
                           discountedTerms?.is_can_not_use_trial && discountedTerms.initial_terms && (
                              <>
                                 <span
                                    data-tooltip-content='This trial has already been used'
                                    data-tooltip-id='ams-bottom-tooltip'
                                    className='line-through'>{discountedTerms.initial_terms}, then</span>
                                  &nbsp;
                              </>
                           )
                        }
                        {discountedTerms.terms}
                     </span>
                  )
               }

               <div
                  className={ cx({
                     'w-full h-9': true,
                     'mt-2.5': isPromo,
                     'mt-6': !isPromo && !availableForContentName,
                     'mt-[38px]': !isPromo && availableForContentName,
                  }) }
               >
                  <Button
                     text={ isPromo ? 'Get this deal' : isUpdate ? 'Upgrade' : 'Select' }
                     classNames='h-full w-full'
                     textSize='small'
                     padding='none'
                     borderRadius='large'
                     onClick={ () => {
                        if(isUpdate){
                           updateMembership()
                        } else {

                           if(!isTokenExists) {
                           // const pageInfo = {
                           //    route_name: 'PURCHASE_MEMBERSHIP',
                           //    page_name: 'purchase memberships',
                           //    route_id: value.id,
                           // }
                              goToJoin(value.id)
                           } else {
                              onClickJoin({ ...value, type: 'membership' })
                           }
                        }
                     } }
                     primaryColor
                  />
               </div>
            </div>

            <DescriptionContent
               description={ value.description }
               contentRef={ r => ref.current = r }
               maxH={ maxH }
               isReadMore={ isReadMore }
               showReadMore={ showReadMore }
               onSetIsReadMore={ bool => onSetIsReadMore(bool) }
            >
               {
                  value.benefits_data && value.benefits_data.length > 0 &&
                  <div
                     className='flex flex-col'
                  >
                     {
                        [...value.benefits_data].map(benefit => {

                           return (
                              <BenefitCard
                                 key={ benefit.id }
                                 name={ benefit.name }
                                 isActive={ !benefit.is_active }
                              />
                           )
                        })
                     }
                  </div>
               }
            </DescriptionContent>
         </div>
      </div>
   )
}


const DescriptionContent = ({
   description,
   children,
   contentRef,
   maxH,
   isReadMore,
   showReadMore,
   onSetIsReadMore,
}) => {
   return (
      <div
         style={ !showReadMore && maxH ? {
            maxHeight: `${ maxH }px`,
         } : {} }
         className='flex flex-col relative mt-6 w-full'>

         <div
            ref={ contentRef }
            style={
               maxH ? {
                  maxHeight: `${ maxH }px`,
                  transition: !isReadMore ? 'max-height 0.5s ease, overflow 1s ease' : 'all 0.5s ease',
               } : {
                  transition: !isReadMore ? 'max-height 0.5s ease, overflow 1s ease' : 'all 0.5s ease',
               } }
            className='flex flex-col relative membership-description-animation z-1 w-full'
         >
            {children && children}
            {
               description && (
                  <span
                     className='text-secondary text-sm leading-5 dark:text-secondary-dark whitespace-pre-wrap flex mt-3'
                  >
                     {description}
                  </span>
               )
            }

         </div>
         {
            showReadMore && (
               <div className='flex h-9 w-[132px] mx-auto z-10 mb-4'>
                  <Button
                     text={ !isReadMore ? 'Show less' : 'Show more' }
                     iconName={ isReadMore ? 'arrow-down' : 'arrow-up' }
                     backgroundColor='transparent'
                     classNames='h-full'
                     padding='none'
                     textMarginX='0 mr-2'
                     textColor='secondary dark:text-secondary-dark dark:text-secondary-dark '
                     fontIconColor='secondary dark:text-secondary-dark dark:text-secondary-dark '
                     textSize='small'
                     fontIconSize='base'
                     onClick={ () => onSetIsReadMore(!isReadMore) }
                  />
               </div>

            )
         }
         {
            (isReadMore && showReadMore) && (
               <div
                  className='absolute left-0 right-0 bottom-0 w-full h-full z-1 rounded-lg'
                  style={ {
                     background: window.site_dark_bg ? 'linear-gradient(180.03deg, rgba(18, 18, 18, 0.12) 71.94%, #121212 83.62%)' : 'linear-gradient(180.03deg, rgba(255, 255, 255, 0.12) 71.94%, #FFFFFF 83.62%)',
                  } }
               />
            )
         }
      </div>

   )
}

MembershipItem.propTypes = {
   value: PropTypes.object,
   onClickJoin: PropTypes.func,
   goToJoin: PropTypes.func,
   availableForContentName: PropTypes.string,
   accessType: PropTypes.string,
   price: PropTypes.any,
   isAvalable: PropTypes.bool,
   isUpdate: PropTypes.bool,
   updateMembership: PropTypes.func,
   isPromo: PropTypes.bool,
   promotion: PropTypes.object,
   screenWidth: PropTypes.number,
   discountedTerms: PropTypes.object,
   isTokenExists: PropTypes.bool,
};
DescriptionContent.propTypes = {
   description: PropTypes.string,
   children: PropTypes.any,
   contentRef: PropTypes.any,
   maxH: PropTypes.any,
   isReadMore: PropTypes.any,
   showReadMore: PropTypes.bool,
   onSetIsReadMore: PropTypes.func,
};

export default React.memo(MembershipItem);
